<template>
  <v-snackbar
    :timeout="10000"
    :color="statusColor"
    v-model="snackbar"
  >
    {{message}}
    <v-btn  flat dark @click="hideResultMessage">
      <v-icon>clear</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'InfoSnackBar',
    computed: {
      ...mapState({
        statusColor: state => state.snackbar.color,
        snackState: state => state.snackbar.snackbar,
        message: state => state.snackbar.message
      }),
      snackbar: {
        get () { return this.snackState },
        set () { this.hideResultMessage() }
      }
    },
    methods: { ...mapActions(['hideResultMessage']) }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/InfoSnackBar/index.vue